import {LevelLink} from './LevelLink';

export class MenuLevel {
  private levelLinks: LevelLink[];
  private parentLevel: number;
  private levelId: number;

  getLinks = (): LevelLink[] => {
    return this.levelLinks;
  }

  getParentLevel = (): number => {
    return this.parentLevel;
  }

  getLevelId = (): number => {
    return this.levelId;
  }

  setLinks = (links: LevelLink[]): void => {
    this.levelLinks = links;
  }

  setParentLevel = (parentLevel: number): void => {
    this.parentLevel = parentLevel;
  }

  setLevelId = (id: number): void => {
    this.levelId = id;
  }


  constructor (links: LevelLink[], parentLevel: number, levelId: number) {
    this.setLinks(links);
    this.setParentLevel(parentLevel);
    this.setLevelId(levelId);
  }

}
